// import { unstable_matchRSCServerRequest } from 'react-router-dom';
import '../styles/Home.css';
import { useState, useEffect, useMemo, useRef } from 'react';
import {usePeople, useReunions, getImgOptions} from '../hooks/hooks_index.js';
import {Loading, MediaImage} from '../components/components_index.js';
import {Link} from 'react-router-dom';

export default function Home({children}) {
  const {data: people, isLoading: peopleLoading, error: peopleError} = usePeople();
  const {data: reunions, isLoading: reunionsLoading, error: reunionsError} = useReunions();
  // const [peopleBirthdays, setPeopleBirthdays] = useState([]);
  // const [peopleAnnivs, setPeopleAnnivs] = useState([]);

  const peopleList = useMemo(() => (people ? Object.entries(people) : []), [people]); 
  // const reunionList = useMemo(() => (reunions ? Object.entries(reunions) : []), [reunions]);

  const today = new Date();
  const todayMonth = today.getMonth()+1;
  const todayDay = today.getDate();
  
  const todayBirth = useMemo(() => {
    if (!peopleList.length) return [];
    return peopleList
      .filter(([_, person]) => {
        const b = person.b_details;
        return (
          Number(b?.b_month) === todayMonth &&
          Number(b?.b_day) === todayDay
        );
      })
      .filter(([id]) => !id.startsWith("P0"))
      .map(([id, person]) => ({
        id,
        name: person.AKA?.split(' ')[0] || person.f_name,
        age:
          person.b_details?.b_year
            ? today.getFullYear() - person.b_details.b_year
            : null,
      }));
  }, [peopleList, todayMonth, todayDay]);

  const todayAnniv = useMemo(() => {
    if (!peopleList.length) return [];
    return peopleList
      .filter(([id]) => id.endsWith("0") && !id.startsWith("P0"))
      .map(([id, person]) => {
        const marriages = person.m_details;
        if (!marriages?.length) return null;
        const marriage = marriages[marriages.length - 1];
        if (marriage.div_year) return null;
        if (
          Number(marriage.m_month) !== todayMonth ||
          Number(marriage.m_day) !== todayDay
        ) {
          return null;
        }
        return {
          id,
          name: person.AKA?.split(" ")[0] || person.f_name,
          spouseID: marriage.spouse,
          yearsMarried:
            marriage.m_year
              ? today.getFullYear() - marriage.m_year
              : null,
        };
      })
      .filter(Boolean);
  }, [peopleList, todayMonth, todayDay]);

  return (
    <Body>
      <HomeTitle />
      <ImageScroll />
      {todayBirth.length > 0 && (
        <BirthBanner birthdays={todayBirth} />
      )}
      {todayAnniv.length > 0 && (
        <AnnivBanner anniversaries={todayAnniv} people={people}/>
      )}
    </Body>
  );
}

function Body({children}) {
  return (
    <div className='home-background'>
      <div className='home-body'>
        {children}
      </div>
    </div>
  );
}

function ImageScroll() {
  // const alt_txt='Scroll image';
  
  const [images, setImages] = useState(); 
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(true);

  const nextImage = () => {
    if (!images?.length) return;
    setCurrentIndex(prevIndex => (prevIndex + 1) % images.length);
  };

  const prevImage = () => {
    if (!images?.length) return;
    setCurrentIndex(prevIndex => (prevIndex - 1 + images.length) % images.length);
  };

  // const progressPercent = ((currentIndex) / (images.length-1)) * 100;
  const progressPercent =
  images?.length > 1
    ? (currentIndex / (images.length - 1)) * 100
    : 0;

  useEffect(() => {
    if (!isPlaying) return;

    const interval = setInterval(nextImage, 6000);
    return () => clearInterval(interval);
    }, [isPlaying, currentIndex, images]);

  const togglePlay = () => setIsPlaying((prev) => !prev)

  useEffect(() => {
    setIsLoading(true)
    getImgOptions({scroll_box: true})
      .then(data => {
        setImages(data);
        setIsLoading(false);
      })
      .catch(err => {
        setError(err.message)
        setIsLoading(false)
      });
  }, []);

  return (
    <div className='image-scroll-box'>
      {isLoading && <Loading />}
      {images &&
        <>
            <div className='scroll-buttons'>
            <button className='scroll-button back-button' onClick={prevImage}>
              {'\u2039'}
            </button>
            <button className='scroll-button next-button' onClick={nextImage}>
              {'\u203A'}
            </button>
          </div>
          <div className='image-holder'>
            <button className='play-button' onClick={togglePlay}>
              {isPlaying ? '❚❚' : '\u25B6'}
            </button>
            <div className='image-stack'>
              {images.map((img, index) => (
                <MediaImage 
                  key={index}
                  className={`scroll-image${index === currentIndex ? ' active' : ''}`} 
                  mediaID={img.media_id} 
                  // containerName = {"scroll-img-container"}
                />
              ))}
            </div>
          </div>
          <div className='progress-bar'>
            <div className='progress-fill' style={{width: `${progressPercent}%`}} />
          </div>
        </>
      }
    </div>
  )
}

function HomeTitle() {
  return (
    <div className='welcome-box'>
      {/* <svg viewBox="0 0 1000 120" xmlns="http://www.w3.org/2000/svg" className='curly-decoration first-curly'>
        <path
          className="welcome-swoop-normal"
          d="M 0,60
            C 100,-5 155,25 170,40
            C 185,55 170,65 160,58
            C 149,50 165,5 200,8
            C 220,10 240,18 260,26
            C 280,34 340,54 370,58
            C 400,64 450,70 480,67
            C 490,67 510,66 540,54
            C 549,50 558,45 569,32
            C 573,28 574,24 575,21
            C 581,34 605,40 608,41
            C 625,45 650,46 670,40
            C 690,35 725,20 745,20
            C 758,19 767,22 774,30
            C 780,40 779,53 770,54
            C 762,53 760,46 764,40
            C 770,30 776,24 790,24
            C 798,24 810,26 835,39
            C 841,42 865,53 885,48
            C 892,46 898,46 929,27
            C 937,22 965,2 1000,8
            "
          fill="none"
          stroke="var(--blue8)"
          stroke-width="var(--line-width)"
          // stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          className="welcome-swoop-highlight"
          d="M 0,60
            C 100,-5 155,25 170,40
            C 185,55 170,65 160,58
            C 149,50 165,5 200,8
            C 220,10 240,18 260,26
            C 280,34 340,54 370,58
            C 400,64 450,70 480,67
            C 490,67 510,66 540,54
            C 549,50 558,45 569,32
            C 573,28 574,24 575,21
            C 581,34 605,40 608,41
            C 625,45 650,46 670,40
            C 690,35 725,20 745,20
            C 758,19 767,22 774,30
            C 780,40 779,53 770,54
            C 762,53 760,46 764,40
            C 770,30 776,24 790,24
            C 798,24 810,26 835,39
            C 841,42 865,53 885,48
            C 892,46 898,46 929,27
            C 937,22 965,2 1000,8
            "
          fill="none"
          stroke="var(--blue4)"
          stroke-width="var(--line-width)"
          // stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg> */}
      <div className='welcome'>
        Welcome to the Spradley Family Website!
      </div>
      <svg viewBox="0 0 1000 120" xmlns="http://www.w3.org/2000/svg" className='curly-decoration'>
        <path
          className="welcome-swoop-normal"
          d="M 0,60
            C 100,-5 155,25 170,40
            C 185,55 170,65 160,58
            C 149,50 165,5 200,8
            C 220,10 240,18 261,26
            C 280,34 340,54 369,58
            C 400,64 450,70 484,67
            C 490,67 514,66 541,54
            C 549,50 559,45 569,31
            C 573,26 574,23 575,21
            C 581,34 605,40 608,41
            C 625,45 650,46 670,40
            C 690,35 725,20 745,20
            C 758,19 767,22 774,30
            C 780,40 779,53 770,54
            C 762,53 760,46 764,40
            C 770,30 776,24 790,24
            C 798,24 810,26 835,39
            C 841,42 865,53 885,48
            C 892,46 898,46 929,27
            C 937,22 965,2 1000,8
            "
          fill="none"
          stroke="var(--blue8)"
          stroke-width="var(--line-width)"
          // stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          className="welcome-swoop-highlight"
          // d="M 0,100
          //   C 100,25 155,55 170,70
          //   C 185,85 170,95 160,88
          //   C 149,80 165,35 200,38
          //   C 220,40 240,48 260,56
          //   C 280,64 340,84 370,88
          //   C 400,94 450,100 480,97
          //   C 490,97 510,96 540,84
          //   C 549,80 558,75 569,62
          //   C 573,58 574,54 575,51
          //   C 581,64 605,70 608,71
          //   C 625,75 650,76 670,70
          //   C 690,65 725,50 745,50
          //   C 758,49 767,52 774,60
          //   C 780,70 779,83 770,84
          //   C 762,83 760,76 764,70
          //   C 770,60 776,54 790,54
          //   C 798,54 810,56 835,69
          //   C 841,72 865,83 885,78
          //   C 892,76 898,76 929,57
          //   C 937,52 965,32 1000,37"
          d="M 0,60
            C 100,-5 155,25 170,40
            C 185,55 170,65 160,58
            C 149,50 165,5 200,8
            C 220,10 240,18 261,26
            C 280,34 340,54 369,58
            C 400,64 450,70 484,67
            C 490,67 514,66 541,54
            C 549,50 559,45 569,31
            C 573,26 574,23 575,21
            C 581,34 605,40 608,41
            C 625,45 650,46 670,40
            C 690,35 725,20 745,20
            C 758,19 767,22 774,30
            C 780,40 779,53 770,54
            C 762,53 760,46 764,40
            C 770,30 776,24 790,24
            C 798,24 810,26 835,39
            C 841,42 865,53 885,48
            C 892,46 898,46 929,27
            C 937,22 965,2 1000,8
            "
          fill="none"
          stroke="var(--blue4)"
          stroke-width="var(--line-width)"
          // stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
}

function BirthBanner({ birthdays }) {
  const videoRef = useRef(null);
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.playbackRate = 0.7;
    }
  }, []);

  function lengthSuffix (age) {
    if (age >= 11 && age <= 13) {
      return `th`;
    }
    const n = age % 10;
    switch (n) {
      case 1: return "st";
      case 2: return "nd";
      case 3: return "rd";
      default: return `th`;
    }
  }

  return (
    <div className="banner-container">
      <video
        ref={videoRef}
        src="/data/fireworks.mp4"
        className="banner-background"
        autoPlay
        muted
        loop
        playsInline
      />
      {birthdays.map((person, index) => (
        <div key={person.id} className="bday-banner">
          <div className="banner-text">
            <Link to={`/people/${person.id}`} className="banner-text">Happy {person.age}{lengthSuffix(person.age)} Birthday, <span>{person.name}</span>!</Link>
          </div>
          {index !== birthdays.length-1 && (
            <div className="banner-block" />
          )}
        </div>
      ))}
    </div>
  );
}

function AnnivBanner({anniversaries, people}) {
  function lengthSuffix (len) {
    if (len >= 11 && len <= 13) {
      return `th`;
    }
    const n = len % 10;
    switch (n) {
      case 1: return "st";
      case 2: return "nd";
      case 3: return "rd";
      default: return `th`;
    }
  }

  return (
    <div className="banner-container anniv-container">
      {anniversaries.map((person) => (
        <div key={person.id} className='anniv-banner'>
          Happy {person.yearsMarried}{lengthSuffix(person.yearsMarried)} Anniversary, <Link to={`/people/${person.id}`} className="banner-text">{person.name}</Link> and <Link to={`/people/${person.spouseID}`} className="banner-text">{people[person.spouseID]?.AKA?.split(" ")[0] || people[person.spouseID]?.f_name || person.spouseID}</Link>!
        </div>
      ))}
    </div>
  );
}